/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 *
 * http://www.neotericdesign.com/blog/2013/3/working-around-chrome-s-contenteditable-span-bug
 */
angular.module('bulbApp.contentEditorModule')

.directive('cleanSpans', cleanSpans);

function cleanSpans() {
  return {
    link: function link(scope, elem, attr) {
      function unwrap(element) {
        var $helper = $('<b>helper</b>');
        var $element = $(element);
        $element.before($helper);
        $helper.after($element.contents());
        $helper.remove();
        $element.remove();
      }
      elem.on('DOMNodeInserted', function(event) {
        if (event.target.tagName === 'SPAN') {
          console.debug('cleaning new span');
          unwrap(event.target);
        } else if (event.target.tagName === 'BR') {
          console.debug('cleaning new br');
          // TODO INDENT : remove unnecessary trailing br from within li elements.
          //var $target = $(event.target);
          //if ($target.is(':last-child')) {
          //  $target.remove();
          //}
        }
      });
    }
  };
}
